import { Component } from '@angular/core';
import { IonButton, IonContent } from '@ionic/angular/standalone';
import { Router } from '@angular/router';
import { GlobalService } from 'src/app/services/global.service';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'app-home',
  templateUrl: 'home.page.html',
  styleUrls: ['home.page.scss'],
  standalone: true,
  imports: [IonButton, IonContent],
})

export class HomePage {
  constructor(
    private globalService: GlobalService
  ) {}

  ionViewDidEnter() {}

  login() {    
    if (this.globalService.envData?.isMoodle && !window.location.href.includes('dashboard.php')) {
      window.location.href = this.globalService.moodleUrl + "/theme/iacdp/pages/dashboard.php?login=true";      
    } else {
      this.globalService.router.navigate(['login']);
    }
  }
}